/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from 'react';
// BASE Components
import BASESvgIcon from '../../../../@BASE/core/BASESvgIcon';
// Material UI
import Avatar from '@mui/material/Avatar';
import CardHeader from '@mui/material/CardHeader';
import Chip from '@mui/material/Chip';
import { lighten } from '@mui/material/styles';

function ContentListItemHeader({ instance, resource }) {

  function handleListItemIcon() {
    switch (resource) {
      case 'lessons':
        return 'heroicons-outline:cube';
      case 'sections':
        return 'heroicons-outline:folder';
      default:
        return 'heroicons-outline:document-text';
    }
  }

  const handleListItemHeaderClasses = () => {
    switch (resource) {
      case 'pages':
        return 'relative items-center border-b-1 py-12 lg:hidden';
      default:
        return 'py-48 relative';
    }
  };

  return (
    <CardHeader
      avatar={
        <Avatar sx={{ bgcolor: 'transparent', color: 'white' }} aria-label={instance.label}>
          <BASESvgIcon size={24}>{handleListItemIcon()}</BASESvgIcon>
        </Avatar>
      }
      title={instance.label}
      titleTypographyProps={{
        color: '#ffffff',
        variant: 'subtitle2',
        fontWeight: 'normal'
      }}
      subheader={instance.title}
      subheaderTypographyProps={{
        color: '#ffffff',
        variant: 'body1',
        fontWeight: 'bold'
      }}
      action={
        resource !== 'pages' && (
          <Chip
            label={
              instance.classification.charAt(0).toUpperCase() +
              instance.classification.slice(1)
            }
            color="secondary"
            size="small"
            className="absolute top-12 right-24"
          />
        )
      }
      className={handleListItemHeaderClasses()}
      sx={{
        backgroundColor: (theme) =>
          theme.palette.mode === 'light'
            ? theme.palette.primary.dark
            : lighten(theme.palette.background.default, 0.03),
        color: 'white'
      }}
    />
  );
}

export default ContentListItemHeader;
